import { useQuery } from "@tanstack/react-query";
import { getCoreAxiosInstance } from "../../api/CoreAxiosInstance";
import { PacketDetailSchema } from "../types";

export function useShadowRunPacket(
  orgCategory: string,
  orgId: string,
  batchId: string,
  packetId: string
) {
  return useQuery({
    queryKey: [
      "shadowRunPacket",
      orgCategory,
      orgId,
      batchId,
      packetId,
    ],
    queryFn: async () => {
      const instance = await getCoreAxiosInstance();
      const { data } = await instance.get(
        `/api/v1/shadow/batches/${orgCategory}/${orgId}/${batchId}/packets/${packetId}`
      );
      return PacketDetailSchema.parse(data);
    },
    enabled: !!orgCategory && !!orgId && !!batchId && !!packetId,
  });
}
